import { AxiosResponse } from 'axios';
import { apiV2 } from './http';
import {
  CreateResellerData,
  ResellerCreateContractData,
  ResellerCreateCustomerData,
  ResellerListParams,
  ResellerListResponse,
  ResellerReportResponse,
} from './interfaces/reseller';

export function listResellerCustomers(
  params?: ResellerListParams,
): Promise<AxiosResponse<ResellerListResponse>> {
  return apiV2.get<ResellerListResponse>('reseller/list', { params });
}

export function createResellerCustomer(
  payload: ResellerCreateCustomerData,
): Promise<AxiosResponse> {
  return apiV2.post('reseller/create', payload);
}

export function createReseller(
  payload: CreateResellerData,
): Promise<AxiosResponse> {
  return apiV2.post('reseller/create-reseller', payload);
}

export function createResellerContract(
  payload: ResellerCreateContractData,
): Promise<AxiosResponse> {
  return apiV2.post('reseller/create/contract', payload);
}

export function getResellerReport(): Promise<
  AxiosResponse<ResellerReportResponse>
> {
  return apiV2.get<ResellerReportResponse>('reseller/report');
}
